import { AUTH_STATUS } from 'store/enums';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_LOGOUT_BBVA
} from 'store/actions/auth';

export default {
  [AUTH_REQUEST]: state => {
    state.status = AUTH_STATUS.loading;
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = AUTH_STATUS.success;
    state.token = resp;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.status = AUTH_STATUS.error;
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    state.token = '';
  },
  [AUTH_LOGOUT_BBVA]: state => {
    state.tokenBBVA = '';
  }
};
